export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">关于我们</h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">妖精漫画网，为漫画爱好者打造的全品类免费阅读平台</p>
        </div>
        <div className="max-w-3xl mx-auto">
          <div className="bg-background-100 rounded-2xl p-6 md:p-10 border border-background-200/60">
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
              妖精漫画网是一个专注于免费漫画在线阅读的综合平台，汇聚了海量韩漫、日漫和国漫资源。自上线以来，我们始终坚持「全本免费、每日更新」的运营理念，为读者提供流畅的下拉式阅读体验。
            </p>
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
              从热血奇幻到甜蜜恋爱，从悬疑魔幻到日常治愈，妖精漫画网大全覆盖了几乎所有热门漫画品类。我们的内容团队每日精心筛选优质漫画，确保更新速度与质量并重，让追更不再成为等待的烦恼。
            </p>
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
              无论你是资深漫迷还是刚刚入坑的新读者，妖精漫画网好看的漫画都能满足你的阅读需求。我们致力于成为中文世界最便捷、最全面的免费漫画在线阅读入口。
            </p>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mt-6">
            {[
              { n: '12,000+', d: '漫画资源' },
              { n: '每日更新', d: '从不间断' },
              { n: '韩日国', d: '三大品类' },
              { n: '全免费', d: '无需注册' },
            ].map((item) => (
              <div key={item.d} className="text-center p-4 bg-background-100 rounded-xl border border-background-200/60">
                <div className="text-lg md:text-xl font-heading text-primary-600 whitespace-nowrap">{item.n}</div>
                <div className="text-xs text-foreground-500 mt-1">{item.d}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}